import { ThunderDispatcher } from '@nu-art/thunderstorm-frontend/index';
export const dispatch_ShowConflictResolution = new ThunderDispatcher('__onShowConflictResolution');
//# sourceMappingURL=show-conflict-resolution.js.map